import React from 'react';
import './Contact.css';

const Contact = () => {
  const whatsappNumber = '905073933413'; // ESR Group Sigorta WhatsApp
  const whatsappMessage = encodeURIComponent('Merhaba, sigorta hakkında bilgi almak istiyorum.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <div className="contact">
      <div className="contact-hero">
        <div className="container">
          <h1>İletişim</h1>
          <p>Bizimle iletişime geçin, size yardımcı olalım</p>
        </div>
      </div>

      <div className="contact-content">
        <div className="container">
          <div className="contact-details-wrapper">
            <div className="contact-info">
              <h2>İletişim Bilgileri</h2>

              <div className="contact-item">
                <div className="contact-icon">📧</div>
                <div>
                  <h3>E-posta</h3>
                  <a href="mailto:info@esrgroupsigorta.com.tr">info@esrgroupsigorta.com.tr</a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">📱</div>
                <div>
                  <h3>WhatsApp</h3>
                  <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                    WhatsApp ile İletişime Geç
                  </a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div>
                  <h3>Telefon</h3>
                  <a href="tel:+905073933413">0507 393 34 13</a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h3>Adres</h3>
                  <p>Barbaros Hayrettin Paşa Mahallesi, 1992. Sokak, Vetro City, No: 16, Daire: 43, Esenyurt/İstanbul</p>
                  <a
                    href="https://www.google.com/maps/dir/?api=1&destination=Vetro+City,+Esenyurt,+İstanbul"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="map-link"
                  >
                    Yol Tarifi Al →
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="map-section">
            <h2>Konumumuz</h2>
            <div className="map-container">
              <iframe
                src="https://maps.google.com/maps?q=Vetro%20City%2C%20Esenyurt%2C%20Istanbul&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="ESR Group Sigorta - Vetro City, Esenyurt"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;


